import type { IconData } from '@stacksjs/iconify-core'

export const industrySlash: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M459.26 96L328 225.697V96h-34.55l-64.44 65.128l22.628 22.628L296 138.92v89.198l37.314 37.315L464 136.303v259.815l32 32V96zM168 16H83.882L168 100.118zm-32 288h32v32h-32zm0 72h32v32h-32zm80-72h32v32h-32zm0 72h32v32h-32zm80 0h32v32h-32z\"/><path fill=\"currentColor\" d=\"M38.627 16H16v480h480v-22.627ZM48 464V70.627l88 88V248h32v-57.373L441.373 464Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default industrySlash
